<script setup>
import AboutSection from '@/components/home/AboutSection.vue'
import AddonServicesSection from '@/components/home/AddonServicesSection.vue'
import ContactSection from '@/components/home/ContactSection.vue'
import HeroSection from '@/components/home/HeroSection.vue'
import LogoBar from '@/components/home/LogoBar.vue'
import PhilosophySection from '@/components/home/PhilosophySection.vue'
import PricingSection from '@/components/home/PricingSection.vue'
import ProcessSection from '@/components/home/ProcessSection.vue'
import ReferencesSection from '@/components/home/ReferencesSection.vue'
import ServicesSection from '@/components/home/ServicesSection.vue'
import TestimonialSection from '@/components/home/TestimonialSection.vue'
</script>

<template>
    <Head>
        <title>SolveCount s.r.o. - účetnictví a daňové poradenství</title>
        <meta
            name="description"
            content="Pomáháme živnostníkům a malým firmám mít ve financích pořádek a čistou hlavu. Spolupráci stavíme na flexibilitě a lidském přístupu."
        />
    </Head>

    <div class="text-brand-900 bg-white">
        <HeroSection />
        <LogoBar />
        <ProcessSection />
        <AboutSection />
        <PhilosophySection />
        <ServicesSection />
        <PricingSection />
        <AddonServicesSection />
        <TestimonialSection />
        <ReferencesSection />
        <ContactSection />
    </div>
</template>
